import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import Buttons from './popups/Buttons';
import PopupFrame from './popups/ui-1';

function ModalNotifycation({ textBtn, isContainer = false,open , title = "",topIcon = null, handleCancel, handleOk = null, message, isVersion3 = false }) {
	const { t } = useTranslation()
  
  if (isVersion3) {
     return (
    <PopupFrame
      title={title}
      open={open}
      onOpenChange={handleCancel}
      className="modal-notifycation"
      centered
      getContainer={isContainer ? false : null}
      width={684}
    >
      <div className="mt-7">
          {topIcon && (
          <img
            src={topIcon}
            alt=""
            className="mx-auto mb-4 w-[55%] max-w-70 object-contain"
          />
        )}
        <div className="w-full flex flex-col gap-2 text-center">
          <div className="text-[#6E4A21] text-[17px] sm:text-[20px] font-semibold">
            {message}
          </div>
        </div>
      </div>
      <div className="px-[20%] pt-[10%]">
        <Buttons
          handleClick={handleOk ? handleOk : handleCancel}
          textBtn={textBtn || t("modal.modal_login.confirm")}
          classItem="mb-[0]"
        />
      </div>
    </PopupFrame>
  );
  }
	return (<Modal
		title={title}
		open={open}
		onCancel={handleCancel}
		className="modal-notifycation"
		centered
		getContainer={isContainer ? false : null}
		width={684}
		footer={
			<div className="foot-login">
				<Button onClick={handleOk ? handleOk : handleCancel} className="button-foot-modal">
					{t("modal.modal_login.ok")}
				</Button>
			</div>
		}
	>
		<div className="modal-notifycation-body">
			{message}
		</div>

	</Modal>);
}

export default ModalNotifycation;